import {
  COLLECTIONS_ADD_WORKFLOW_TO_COLLECTION_BEGIN,
  COLLECTIONS_ADD_WORKFLOW_TO_COLLECTION_SUCCESS,
  COLLECTIONS_ADD_WORKFLOW_TO_COLLECTION_FAILURE,
  COLLECTIONS_ADD_WORKFLOW_TO_COLLECTION_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function addWorkflowToCollection(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: COLLECTIONS_ADD_WORKFLOW_TO_COLLECTION_BEGIN,
    });
    const { projectId, version, collectionUuid } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/workflows/${collectionUuid}/collection`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: COLLECTIONS_ADD_WORKFLOW_TO_COLLECTION_SUCCESS,
              data: res.data,
              collectionUuid: args.collectionUuid,
            });
            Mixpanel.track('Created Workflow in Collection');
            toast.success('Created Successfully !');
            resolve(res.data);
          } else {
            dispatch({
              type: COLLECTIONS_ADD_WORKFLOW_TO_COLLECTION_FAILURE,
              data: { error: err },
            });
            Mixpanel.track('Failed to create workflow in collection');
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject(err);
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_ADD_WORKFLOW_TO_COLLECTION_FAILURE,
            data: { error: err },
          });

          Mixpanel.track('Failed to create workflow in collection');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});

          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissAddWorkflowToCollectionError() {
  return {
    type: COLLECTIONS_ADD_WORKFLOW_TO_COLLECTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_ADD_WORKFLOW_TO_COLLECTION_BEGIN:
      return {
        ...state,
        addWorkflowToCollectionPending: true,
        addWorkflowToCollectionError: null,
      };

    case COLLECTIONS_ADD_WORKFLOW_TO_COLLECTION_SUCCESS:
      let projectCollections = state.projectCollections;
      let index = projectCollections.findIndex((item) => {
        return item.uuid === action.collectionUuid;
      });
      projectCollections[index] = action.data;
      return {
        ...state,
        addWorkflowToCollectionPending: false,
        addWorkflowToCollectionError: null,
        selectedCollection: action.data,
        projectCollections,
      };

    case COLLECTIONS_ADD_WORKFLOW_TO_COLLECTION_FAILURE:
      return {
        ...state,
        addWorkflowToCollectionPending: false,
        addWorkflowToCollectionError: action.data.error,
      };

    case COLLECTIONS_ADD_WORKFLOW_TO_COLLECTION_DISMISS_ERROR:
      return {
        ...state,
        addWorkflowToCollectionError: null,
      };

    default:
      return state;
  }
}
